// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-program-new__payment-options{margin-top:20px}.program-card-section{padding-top:14px;border-top:1px solid var(--color-silver)}.program-card-section--hidden{border:none}.program-card-section__not-receiving-referrals{color:var(--color-rosso)}", ""]);
// Exports
module.exports = exports;
